export class RetrieveCaseByFiltersRequestModel {

    constructor(values?: Partial<RetrieveCaseByFiltersRequestModel>) {
        Object.assign(this, values);
    }

    sysparm_query!: string;
    orgId!: string;
    ssoId!: string;
    email!: string;
    status!: string[];
    formType!: string;
    caseSysId!: string;
    attachSysId!: string;

    public static parseValues(json: any) {
        if (!json) {
            return new RetrieveCaseByFiltersRequestModel();
        }

        const responseDetails = {
            sysparm_query: json.sysparm_query,
            orgId: json.orgId,
            ssoId: json.ssoId,
            email: json.email,
            status: json.status,
            formType: json.formType,
            caseSysId: json.caseSysId,
            attachSysId: json.attachSysId
        };

        return new RetrieveCaseByFiltersRequestModel(responseDetails);
    }

}
